import { BusTicketCardResponse, BusTicketSeatResponse } from './index.model';

export const mappingBusTicketCard = (payload: BusTicketCardResponse): BusTicketCardResponse => {
    // const mapData = (payload?.expeditions || []).map((item: BusTicketCardModel) => ({
    //     ...item,
    // }));
    return {
        expeditions: payload.expeditions,
        companies: payload.companies,
        infos: payload.infos,
        success: payload.success,
        error_code: payload.error_code,
        error: payload.error,
    };
};

export const mappingBusTicketSeat = (payload: BusTicketSeatResponse): BusTicketSeatResponse => {
    // const mapData = (payload?.data || []).map((item: BusTicketSeatModel) => ({
    //     ...item,
    // }));
    return {
        data: payload.data,
        success: payload.success,
        error_code: payload.error_code,
        error: payload.error,
        stop: payload.stop,
    };
};
